import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Dropdown } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import Details from "./details";
import MentoringSession from "../../Component/MentoringSession";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { imgPath } from "../../utils/imagePath";
import { getSubdomainPath, UCWords } from "../../utils/helpers";
import DToolkit from "./dtoolkit";
import Moment from "moment";
import Feedback from "./Feedback";
import ReportUser from "../Forum/reportUser";
import { Tooltip } from "@mui/material";
import config from "../../config";
import ReactPaginate from "react-paginate";
import queryString from "query-string";
import { getDatabase, ref, get, set } from "firebase/database";
import { useDispatch, useSelector } from "react-redux";
import { loadRegMenteeLogs } from "./Slice/menteesLogSlice";
import PropTypes from "prop-types";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const CustomToggle = React.forwardRef(
  ({ children, onClick }, ref) => (
    <button
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(e);
        }
      }}
      style={{ border: "none", backgroundColor: "white" }}
    >
      {children}
      <span className="threedots" />
    </button>
  )
);

CustomToggle.displayName = "CustomToggle";

CustomToggle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};

const Index = (props) => {

  const { mentees, pagination } = useSelector((state) => state.menteesLog);
  const { userInfo } = useSelector((state) => state?.user);

  const subDomainPath = getSubdomainPath();

  const dispatch = useDispatch();
  const { title } = props;

  const [room, setRoom] = useState({ roomname: "" });

  const location = useLocation();
  const history = useNavigate();
  const [completedMenteeList, setCompletedMenteeList] = useState([]);
  const [rejectedMenteeList, setRejectedMenteeList] = useState([]);
  const [stepsLabels, setStepsLabels] = useState({});

  const menteesToRender = mentees.length > 0 ? mentees : completedMenteeList;

  console.log("", completedMenteeList, rejectedMenteeList);

  const getCompletedMenteeList = (page = 10) => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    if (params.get("page")) {
      page = queryStringParsed["page"];
    }
    agent
      .get(API.LOAD_CUSTOMER + `/getCompletedMenteeList?page=${page}`, {})
      .then((res) => {
        setCompletedMenteeList(res.data.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getRejectedMenteeList = (page = 1) => {
    agent
      .get(API.LOAD_CUSTOMER + "/getRejectedMenteeList", {})
      .then((res) => {
        setRejectedMenteeList(res.data.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getCompletedMenteeList();
    getRejectedMenteeList();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);

    const request = {};

    if (params.get("sort")) {
      request.sort = queryStringParsed["sort"];
      request.direction = queryStringParsed["direction"];
    }

    if (params.get("page")) {
      request.page = queryStringParsed["page"];
    }

    if (params.get("keyword")) {
      request.keyword = queryStringParsed["keyword"];
    }

    document.title = title;

    async function fetchData() {
      try {
        const res = await dispatch(
          loadRegMenteeLogs({
            request,
            status: 4,
          })
        ).unwrap();
        setStepsLabels(
          res?.steps_labels || {}
        );
      } catch (error) {
        console.error(
          "Failed to load pending requests",
          error
        );
      }
    }

    fetchData();

  }, [title, dispatch, location]);

  const [userData, setUserData] = useState({});

  const writeReview = (e, mentee_id, mentor_id, review) => {
    e.preventDefault();
    setModalShow(true);
    setUserData({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentor_review: review,
    });
  };
  const [modalShow, setModalShow] = useState(false);

  const downloadResume = (e, url) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [room, history]);

  const handleClickChat = async (item) => {
    try {
      const roomUser =
        item.mentor_id > item.mentee_id
          ? `${item.mentor_id}_${item.mentee_id}`
          : `${item.mentee_id}_${item.mentor_id}`;

      const db = getDatabase();
      const time = Moment.utc().valueOf();

      const message = {
        mentor_name: item?.mentor_name || "",
        mentor_image: userInfo?.image || "",
        mentor_id: item?.mentor_id,
        mentee_name: item?.mentee_name || "",
        mentee_image: item?.mentee_image || "",
        mentee_id: item?.mentee_id,
        device_type: "Web",
        message: "",
        key: roomUser,
        role_id: userInfo?.role_id || "",
        status: 0,
        time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
        epoch: -1 * time,
      };

      setRoom((prev) => ({ ...prev, roomname: roomUser }));

      const mentorRef = ref(db, `users/${item.mentor_id}/${roomUser}`);
      if (!(await get(mentorRef)).exists()) {
        await set(mentorRef, message);
      }

      const menteeRef = ref(db, `users/${item.mentee_id}/${roomUser}`);
      if (!(await get(menteeRef)).exists()) {
        await set(menteeRef, message);
      }
    } catch (error) {
      console.error("Error creating chat room:", error);
    }
  };


  const [toolkitData, setToolkitData] = useState({});

  const viewToolkit = (
    e,
    mentee_id,
    mentor_id,
    diagnostics,
    diagnostics_sdate
  ) => {
    e.preventDefault();
    setToolkitModalShow(true);
    setToolkitData({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentee_diagnostics: diagnostics,
      diagnostics_sdate: diagnostics_sdate,
    });
  };

  const [modelData, setModelData] = useState("");
  const [model, setModel] = useState(false);
  const [toolkitModalShow, setToolkitModalShow] = useState(false);
  const [userData2, setUserData2] = useState({});
  const [reportModalShow, setReportModalShow] = useState(false);
  const [sessionModel, setSessionModel] = useState(false);
  const [viewPage, setViewPage] = useState(0);

  const viewReportModal = (e, item) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData2({ item: item, from: "user" });
  };


  const isEmptyValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null" ||
      value === "undefined"
    );
  };

  const normalizeArray = (value) => {

    if (!value) return [];

    // array
    if (Array.isArray(value)) {

      return value
        .map((item) => {

          if (typeof item === "object") {

            return (
              item?.title ||
              item?.label ||
              item?.name ||
              item?.rep_board_title ||
              item?.rep_company_name ||
              ""
            );
          }

          return item;
        })
        .filter(Boolean);
    }

    // string
    if (typeof value === "string") {

      return value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [];
  };

  const dynamicFields = [

    {
      key: "program_study_id",
      label: "Program of Study",
      type: "text",
      keys: [
        "program_study_id",
        "mentee_program_study_id_data",
        "mentee_program_study_other",
      ],
    },

    {
      key: "board_entity_type",
      label: "Board Entity Type Experience",
      type: "array",
      keys: [
        "board_entity_type",
        "mentee_board_entity_type",
      ],
    },

    {
      key: "years_of_board_experience",
      label: "Year of Board Experience",
      type: "text",
      keys: [
        "years_of_board_experience",
        "mentee_years_of_board_experience",
      ],
    },

    {
      key: "accredited_director",
      label: "SID Accredited Director",
      type: "array",
      keys: [
        "accredited_director",
        "mentee_accredited_director",
      ],
    },

    {
      key: "course_completed",
      label: "Course Completed",
      type: "array",
      keys: [
        "course_completed",
        "mentee_course_completed",
      ],
    },

    // {
    //   key: "mentee_past_board_roles",
    //   label: "Current / Past Board Roles",
    //   type: "board_roles",
    //   keys: [
    //     "mentee_past_board_roles",
    //   ],
    // },

  ];

  const getDynamicValue = (item, key) => {
    if (item?.reg_fields && Object.hasOwn(item.reg_fields, key)) {
      return item.reg_fields[key];
    }
    if (item?.reg_feilds && Object.hasOwn(item.reg_feilds, key)) {
      return item.reg_feilds[key];
    }
    return item?.[key];
  };

  const getArrayValue = (value) => {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === "string") {
      if (value.includes(",")) {
        return value.split(",").map((item) => item.trim()).filter(Boolean);
      }
      if (value.trim().length > 0) {
        return [value.trim()];
      }
    }
    return [];
  };

  const getDisplayText = (item, key, fallbackValue) => {
    const value = getDynamicValue(item, key);
    if (!isEmptyValue(value)) {
      return value;
    }
    return fallbackValue;
  };

  const dynamicFieldsByKey = Object.fromEntries(
    dynamicFields.map((field) => [field.key, field])
  );

  const dynamicFieldReservedKeys = new Set([
    "image",
    "is_privacy",
    "first_name",
    "last_name",
    "full_name",
    "country_image_path",
    "user_availability_check",
    "is_reached_limit",
    // "all_main_area",
    // "all_sub_area",
    // "domains",
    // "mantee_all_main_area",
    // "mentee_all_main_area",
    // "organization",
    // "position",
    "reg_fields",
    "reg_feilds",
    "fields",
    "labels",
    "mentor_id",
    "mentee_id",
    "status",
    "session_start_date",
    "session_end_date",
    "mentee_resume",
    "mentee_review",
    "mentee_name",
    // "mentee_organization",
    // "mentee_position",
    "mentee_about",
    "mentee_linkedin",
    "linkedin",
    "resume",
    "mn_open_to_talk",
    "mn_loking_for_coach"
  ]);

  const getRegFieldLabel = (regFields, key) =>
    regFields
      ?.flatMap((step) => step?.reg_feilds || [])
      ?.find((field) => field.reg_key === key);

  const getDynamicFieldLabel = (item, key) => {
    const regField = getRegFieldLabel(
      item?.reg_feilds,
      key
    );

    const label =
      stepsLabels?.[key] ||
      item?.steps_labels?.[key] ||
      item?.fields?.[key] ||
      regField?.label ||
      regField?.reg_label ||
      regField?.label_name ||
      regField?.name;

    return label || UCWords(key.replaceAll("_", " "));
  };

  const getRegFeildsOrderedKeys = (item) => {
    if (Array.isArray(item?.reg_feilds)) {
      return item.reg_feilds.flatMap((step) =>
        Array.isArray(step?.reg_feilds)
          ? step.reg_feilds.map((field) => field.reg_key)
          : []
      );
    }

    if (item?.reg_feilds && typeof item.reg_feilds === "object") {
      return Object.keys(item.reg_feilds);
    }

    return [];
  };

  const getDynamicFieldKeys = (item) => {
    const orderedKeys = getRegFeildsOrderedKeys(item);
    if (orderedKeys.length > 0) {
      return orderedKeys.filter((key) => !dynamicFieldReservedKeys.has(key));
    }
    if (item?.reg_fields && Object.keys(item.reg_fields).length > 0) {
      return Object.keys(item.reg_fields).filter(
        (key) => !dynamicFieldReservedKeys.has(key)
      );
    }
    return dynamicFields
      .map((field) => field.key)
      .filter((key) => !dynamicFieldReservedKeys.has(key));
  };

  const renderDynamicField = (item, key) => {
    const value = getDynamicValue(item, key);
    if (isEmptyValue(value)) {
      return null;
    }

    const label = getDynamicFieldLabel(item, key);
    const config = dynamicFieldsByKey[key];
    const type = config?.type || (Array.isArray(value) ? "array" : "text");

    if (key === "mentee_about" || key === "about") {
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{label}</h3>
          <p>{value}</p>
        </div>
      );
    }

    

    if (key === "domains") {
      const domains = typeof value === "string"
        ? value
          .split("||")
          .map((item) => item.trim())
          .filter(Boolean)
        : [];

      if (!domains.length) return null;

      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{label}</h3>

          <div className="domain_wrapper">
            {domains.map((domain, index) => (
              <span key={index} className="domain_badge">
                {domain}
              </span>
            ))}
          </div>
        </div>
      );
    }

    if (key === "objective") {
      const objective = typeof value === "string"
        ? value
          .split("||")
          .map((item) => item.trim())
          .filter(Boolean)
        : [];

      if (!objective.length) return null;

      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{label}</h3>

          <div className="domain_wrapper">
            {objective.map((objective, index) => (
              <span key={index} className="domain_badge">
                {objective}
              </span>
            ))}
          </div>
        </div>
      );
    }

    if (key === "past_board_roles") {
      const pastBoardRole = typeof value === "string"
        ? value
          .split("||")
          .map((item) => item.trim())
          .filter(Boolean)
        : [];

      if (!pastBoardRole.length) return null;

      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{label}</h3>

          <div className="domain_wrapper">
            {pastBoardRole.map((roleData, index) => (
              <span key={index} className="domain_badge">
                {roleData}
              </span>
            ))}
          </div>
        </div>
      );
    }


    if (type === "array" || (typeof value === "string" && value.includes(",") && !config?.type)) {
      const listItems = getArrayValue(value);
      if (listItems.length === 0) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{label}</h3>
          <ul>
            {listItems.map((itemValue, idx) => (
              <li key={`${key}-${idx}`}>
                {typeof itemValue === "object"
                  ? itemValue.title || itemValue.label || itemValue.name || itemValue
                  : itemValue}
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return (
      <div className="mentro_text" key={key}>
        <h3 className="mb-1">{label}</h3>
        <ul>
          <li>{value}</li>
        </ul>
      </div>
    );
  };

  const handlePageClick = (data) => {
    setViewPage(data.selected);
    let page = data.selected + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history({
      pathname: "/mentees-logs",
      search: "?" + params,
    });
    window.scrollTo(0, 0);
  };

  return (

    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h2 className="dash_heading">Past Mentees</h2>
          <div className="box_wrap shadow-sm bg-white mentor_box">

            {/* {mentees && */}
            {menteesToRender.map((item, key) => (
              <div
                className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap"
                key={item.mentee_id}
              >
                <div className="mentro_details_leftbar">
                  <div className="mentor_pic">
                    <img
                      src={
                        item?.reg_fields?.image ||
                        getDisplayText(item, "mentee_image", item?.mentee_image) ||
                        imgPath + "mentor_women_two.png"
                      }
                      alt="career mentor near me"
                      onError={(e) => {
                        e.target.src = imgPath + "mentor_women_two.png";
                      }}
                    />
                  </div>
                  {getDisplayText(item, "linkedin", item?.reg_feilds?.linkedin) && <div className="profile_btn mt-3">
                    <a
                      href={getDisplayText(item, "linkedin", item?.reg_feilds?.linkedin)}
                      className="link_btn btn btn_red m-0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={"/assets/images/linkedin.png"}
                        className="me-2 bg-white"
                        alt="career mentoring services"
                      />{""}
                      Linkedin Profile
                    </a>
                  </div>}
                  {item.mentee_diagnostics_sdate !== "0" && (
                    <div className="profile_btn mt-3">
                      <Link
                        to=""
                        className="link_btn btn btn_red m-0"
                        onClick={(e) => {
                          viewToolkit(
                            e,
                            item.mentee_id,
                            item.mentor_id,
                            item.mentee_diagnostics,
                            item.mentee_diagnostics_sdate
                          );
                        }}
                      >
                        <img
                          src="/assets/images/notification_icon.png"
                          alt="review_icon"
                          className="me-2 bg-white"
                        />
                        {(subDomainPath === "siddev" || subDomainPath === "siduat" || subDomainPath === "sid") ? "Self Assessment Tool" : "Goal Setting"}
                      </Link>
                    </div>
                  )}
                  <div className="extar_info_link">
                    <ul className="px-0 pt-2 mentor_log">
                      {subDomainPath !== 'siddev' && (
                        <li>
                          {getDisplayText(item, "mn_open_to_talk", item.mn_open_to_talk) == 1 && (
                            <Tooltip
                              size="4xl"
                              title={<h5>{config?.mn_open_to_talk}</h5>}
                              describeChild
                              arrow
                            >
                              <img src={imgPath + "usermind.svg"} alt="User mind icon" />
                            </Tooltip>
                          )}
                        </li>
                      )}

                      {subDomainPath !== 'siddev' && (

                        <li>
                          {getDisplayText(item, "mn_loking_for_coach", item.mn_loking_for_coach) == 1 && (
                            <Tooltip
                              size="4xl"
                              title={<h5>{config?.mn_loking_for_coach}</h5>}
                              describeChild
                              arrow
                            >
                              <img src={imgPath + "useraward.svg"} alt="User award icon" />
                            </Tooltip>
                          )}
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div className="mentro_details_sidebar">

                  {/* TOP SECTION */}
                  <div className="row">

                    <Col xl={4}>
                      <div className="d-flex">
                        <div className="name_info main_area_Details">

                          <h4 className="mb-0">
                            {getDisplayText(
                              item,
                              "mentee_name",
                              [
                                getDynamicValue(item, "first_name"),
                                getDynamicValue(item, "last_name"),
                              ]
                                .filter(Boolean)
                                .join(" ")
                            )}
                          </h4>

                          {/* <h5>
                            <span className="d-block">
                              {getDisplayText(
                                item,
                                "mentee_organization",
                                item?.mentee_organization
                              )}
                            </span>
                          </h5>

                          <h5>
                            {getDisplayText(
                              item,
                              "mentee_position",
                              item?.mentee_position
                            )}
                          </h5>

                          {item?.reg_fields?.domains && (
                            <h5>
                              {item?.reg_fields?.domains
                                ?.split("||")
                                ?.map((domain) => domain.trim())
                                ?.filter(Boolean)
                                ?.join(", ")}
                            </h5>
                          )} */}

                        </div>
                      </div>
                    </Col>

                    <Col xl={8}>
                      <div className="current-mentees profile_btn d-flex justify-content-end align-items-center">

                        <button
                          className="link_btn btn btn_red"
                          onClick={() => {
                            setSessionModel(true);
                            setModelData(item);
                          }}
                        >
                          Mentoring Session
                        </button>

                        {item?.mentee_review && (
                          <button
                            className="link_btn btn btn_red"
                            onClick={() => {
                              setModel(true);
                              setModelData(item);
                            }}
                          >
                            Feedback
                          </button>
                        )}

                        <button
                          className="link_btn btn btn_red"
                          onClick={() => handleClickChat(item)}
                        >
                          <img
                            src="/assets/images/msg.png"
                            alt="msg_icon"
                            className="me-2 bg-white"
                          />{" "}
                          Send Message{" "}
                        </button>

                        <button
                          className="link_btn btn btn_red"
                          onClick={(e) => {
                            writeReview(
                              e,
                              item.mentee_id,
                              item.mentor_id,
                              item.mentor_review
                            );
                          }}
                        >
                          <img
                            src="/assets/images/review_blue.png"
                            alt="review"
                            className="me-2 bg-white"
                          />

                          {
                            item?.mentor_review
                              ? "Update Review"
                              : "Write A Review"
                          }
                        </button>

                        <Link
                          to=""
                          className="link_btn btn btn_red"
                          onClick={(e) => e.preventDefault()}
                        >
                          Completed
                        </Link>

                        <Dropdown>
                          <Dropdown.Toggle as={CustomToggle} />
                          <Dropdown.Menu
                            style={{ marginTop: "10px" }}
                            size="sm"
                            title=""
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                viewReportModal(e, item);
                              }}
                            >
                              Report
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>

                      </div>
                    </Col>

                  </div>

                  {/* DATE SECTION */}
                  <ul className="date_list py-2 py-md-4">
                      <div className="d-flex align-items-center gap-5">
                    <li className="d-flex align-items-center">

                      <div className="date_icon">
                        <img
                          src="/assets/images/calender.png"
                          alt="calendar"
                        />
                      </div>

                      <div className="date_content ps-2">
                        <span className="d-block">
                          Session start date
                        </span>

                        <span className="d-block date">
                          {item?.session_start_date}
                        </span>
                      </div>

                    </li>

                    <li className="d-flex align-items-center">

                      <div className="date_icon">
                        <img
                          src="/assets/images/calender.png"
                          alt="calendar"
                        />
                      </div>

                      <div className="date_content ps-2">
                        <span className="d-block">
                          Session end date
                        </span>

                        <span className="d-block date">
                          {item?.session_end_date}
                        </span>
                      </div>

                    </li>
                    </div>

                    {
                      item?.mentee_resume && (
                        <li className="d-flex align-items-center">

                          <div className="date_icon">
                            <img
                              src="/assets/images/pdf.png"
                              alt="resume"
                            />
                          </div>

                          <div className="date_content ps-2">

                            <Link
                              to=""
                              className="d-block date color_red"
                              style={{
                                textDecoration: "underline",
                              }}
                              onClick={(e) => downloadResume(e, item?.mentee_resume)}
                            >
                              Download Resume
                            </Link>
                          </div>
                        </li>
                      )
                    }
                  </ul>
                  {/* DYNAMIC FIELDS */}
                  {getDynamicFieldKeys(item).map((key) => renderDynamicField(item, key))}
                </div>
              </div >
            ))}
            {(menteesToRender.length === 0 || pagination?.total === 0) && (
              <div className="text-center">No past mentees found.</div>
            )}
            {pagination?.total_pages && !(mentees.length === 0 || pagination?.total === 0) && (
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                siblingCount={5}
                forcePage={viewPage}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pagination.total_pages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={(v) => handlePageClick(v)}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            )}
          </div>
        </div>
      </div>
      {
        toolkitModalShow && (
          <DToolkit
            show={toolkitModalShow}
            userdata={toolkitData}
            onHide={() => setToolkitModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        sessionModel && (
          <MentoringSession
            show={sessionModel}
            userInfo={userInfo}
            userdata={modelData}
            dispatch={dispatch}
            onHide={() => setSessionModel(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        reportModalShow && (
          <ReportUser
            show={reportModalShow}
            userdata={userData2}
            onHide={() => setReportModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        model && (
          <Feedback
            show={model}
            userdata={modelData}
            onHide={() => setModel(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        modalShow && (
          <Details
            show={modalShow}
            userdata={userData}
            onHide={() => setModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
    </div >
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Index;
